import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/tj6ckfmk9h/:dynamicPart/:activityCode?',
    name: 'draw',
    component: () => import('../views/draw/scrollPrize.vue')
  },
  {
    path: '/advertising',
    name: 'advertising',
    component: () => import('../views/draw/advertising.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
